<template>
  <div>
    <AlertBox v-if="$cannot('manageUsers', { for: 'User' })" type="warning" class="mt-5" data-testid="user-no-perm-alert">
      {{ t('PartnerCompany.noPartnerCompany') }}
    </AlertBox>
    <ContentCard v-else data-testid="user-list">
      <template #header>
        <div class="my-6 flex flex-col gap-3 tablet:flex-row tablet:justify-between tablet:gap-0">
          <h2 data-testid="user-list-heading">{{ t('UserManagement.UserList.title') }}</h2>
          <RouterLink class="btn-primary-color-s" data-testid="user-list-create-top" :to="{ name: 'createUser' }">
            {{ t('UserManagement.UserList.createNewUserCTA') }}
          </RouterLink>
        </div>
      </template>
      <!-- User column -->
      <div v-if="props.loading" class="py-5 text-center" data-testid="user-list-loading">
        <ProgressBarCircular />
      </div>
      <template v-else>
        <UserItem
          v-for="user in props.users"
          :key="user.id"
          :user="user"
          :for-partner-company-id="currentPartnerCompanyId"
          @reload-users="emit('reloadUsers')"
        />
      </template>

      <template #footer>
        <div class="text-right">
          <RouterLink class="btn-primary-color-s" data-testid="user-list-create-bottom" :to="{ name: 'createUser' }">
            {{ t('UserManagement.UserList.createNewUserCTA') }}
          </RouterLink>
        </div>
      </template>
    </ContentCard>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

import type { User } from '@/gql/myomr'
import { useRoleRedirect } from '@/services/roleRedirect'
import { $cannot } from '@/services/roles'
import { useMeStore } from '@/stores'

import { default as UserItem } from './UserItem.vue'

useRoleRedirect('manageUsers')

const props = defineProps<{
  users: User[]
  loading: boolean
}>()

const emit = defineEmits(['reloadUsers'])

const { t } = useI18n()
const meStore = useMeStore()

const currentPartnerCompanyId = computed(() => meStore.currentPartnerCompanyId || '')
</script>
